define(function(require, exports, module) {
    const $ = require('j');
    const core = require('core');
    const _ = require('underscore');
    const MenuView = require('modules/menu/menu.view');

    module.exports = MenuView.extend({

        /**
         * @override
         */
        subscribe: function() {
            MenuView.prototype.subscribe.apply(this);

            $(window).on('resize.menu__nav-wrapper', _.throttle(this.handleScroll.bind(this), 300));
        },

        /**
         * @override
         */
        render: function() {
            MenuView.prototype.render.apply(this);

            this.handleScroll();

            return this;
        },

        /**
         * @override
         * Add active class for menu item and area-current attribute
         */
        setActiveMenu: function(pageUrl) {
            this.$('.active')
                .removeAttr('area-current')
                .removeClass('active');

            const currentParentItems = this.model.getCurrentParentItems(pageUrl);
            const currentItem = this.model.getCurrentItem(pageUrl);
            const currentParentItem = this.model.getCurrentParentItem(pageUrl);

            [...currentParentItems, currentItem, currentParentItem].forEach(function(item) {
                if (!item) {
                    return;
                }

                var $link = this.$('[data-url="' + item.friendlyURL + '"]');

                !$link.hasClass('fn-accordion') && $link.attr('area-current', 'page').addClass('active');
            }, this);
        },

        /**
         * @override
         */
        handleLinkNavigate: function(event) {
            event.preventDefault();

            const path = event.currentTarget.getAttribute('href') || event.currentTarget.dataset.url;
            const target = event.currentTarget.getAttribute('target');
            const [navigateTo, hash] = /\/kambi#/.test(path) ? path.split('#') : [path, ''];

            core.navigate(navigateTo, { target: target });

            if (hash) {
                location.hash = hash;
            }
        },

        handleScroll: function() {
            if (!this.isDesktopMenu()) {
                return;
            }

            const wrapper = this.$('.menu__nav-wrapper');
            const childTotalWidth = this.$('.menu__nav-item').reduce((sum, el) => sum + el.offsetWidth, 0);
            const parentWidth = parseInt(wrapper.css('width')) - parseInt(wrapper.css('paddingLeft')) - parseInt(wrapper.css('paddingRight'));

            this.$('.help-center').toggleClass('relativePosition', childTotalWidth > parentWidth);
        }
    });
});
